import React from 'react';
import { Link } from 'react-router-dom';

import Waypoint from 'react-waypoint';
import spirit from 'spiritjs';
// import { load } from 'spiritjs';

var animation = (num) => {
  spirit.load('./animation/button-'+num+'.json').then(group => {
    group.at(0).construct().tweenFromTo(0, 1.5).play() // play first group
  });
}

var animationRev = (num) => {
  spirit.load('./animation/button-'+num+'.json').then(group => {
    group.at(0).construct().seek(1.5).play() // play first group
  });
}

export class ButtonButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noref: props.noref,
      link: '/' + this.props.buttonLink + '?refbook=' + this.props.history
    };
  }

  componentDidMount() {
    if (this.state.noref) {
      this.setState({ link: '/' + this.props.buttonLink })
    }
  }

  render() {
    return (
      <Link to={this.state.link}>
        <div
          className={"click-button click-button--" + this.props.align}
          onMouseEnter={() => animation(this.props.idNumber)}
          onMouseLeave={() => animationRev(this.props.idNumber)}>
          <span data-spirit-id={"button-button-text-" + this.props.idNumber}>{this.props.buttonText} {this.props.buttonLink}</span>
          <Waypoint onEnter={() => spirit.loadAnimation({ path: './animation/buttonwaypoint-'+this.props.idNumber+'.json' })} />
          <div className="button-button" data-spirit-id={"button-button-" + this.props.idNumber}>
            <svg
              id={'main-button-' + this.props.idNumber}
              className="main-button"
              width="53px"
              height="53px"
              viewBox="0 0 53 53"
              overflow="visible"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink">
              <g transform="translate(-869.000000, -654.000000)">
                  <g id="Group-5-Copy" fill="#E383EA" fillRule="evenodd" transform="translate(651.000000, 651.000000)">
                      <path d="M244.974803,55.4236785 C259.334206,55.4236785 270.974803,43.783082 270.974803,29.4236785 C270.974803,15.064275 259.334206,3.42367852 244.974803,3.42367852 C230.615399,3.42367852 218.974803,15.064275 218.974803,29.4236785 C218.974803,43.783082 230.615399,55.4236785 244.974803,55.4236785 Z M239.687994,27.5409199 C241.224537,27.5409199 242.47015,26.2898903 242.47015,24.746667 C242.47015,23.2034438 241.224537,21.9524141 239.687994,21.9524141 C238.151451,21.9524141 236.905837,23.2034438 236.905837,24.746667 C236.905837,26.2898903 238.151451,27.5409199 239.687994,27.5409199 Z M250.261612,27.5409199 C251.798154,27.5409199 253.043768,26.2898903 253.043768,24.746667 C253.043768,23.2034438 251.798154,21.9524141 250.261612,21.9524141 C248.725069,21.9524141 247.479455,23.2034438 247.479455,24.746667 C247.479455,26.2898903 248.725069,27.5409199 250.261612,27.5409199 Z M239.687994,36.8949429 C241.224537,36.8949429 242.47015,35.6439133 242.47015,34.10069 C242.47015,32.5574668 241.224537,31.3064371 239.687994,31.3064371 C238.151451,31.3064371 236.905837,32.5574668 236.905837,34.10069 C236.905837,35.6439133 238.151451,36.8949429 239.687994,36.8949429 Z M250.261612,36.8949429 C251.798154,36.8949429 253.043768,35.6439133 253.043768,34.10069 C253.043768,32.5574668 251.798154,31.3064371 250.261612,31.3064371 C248.725069,31.3064371 247.479455,32.5574668 247.479455,34.10069 C247.479455,35.6439133 248.725069,36.8949429 250.261612,36.8949429 Z" transform="translate(244.974803, 29.423679) rotate(-353.000000) translate(-244.974803, -29.423679) "></path>
                  </g>
              </g>
            </svg>
          </div>
        </div>
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ButtonButton.js